import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import IncludeData from './IncludeData';
import DataType from './DataType';
import HarvestCrop from '../HarvestCrop';
import HarvestDate from './HarvestDate';

const baseString = 'vra-harvest-history-cci-row';
const classString = classNames({
  [`${baseString}`]: true
});

const includeDataClassName = 'vra-history-multi-season-table--include';
const dataTypeClassName = 'vra-history-multi-season-table--data-type';
const cropHarvestedClassName = 'vra-history-multi-season-table--crop-harvested';
const dateHarvestedClassName = 'vra-history-multi-season-table--date-harvested';

const HistoryCciRow = ({
  cropList,
  date,
  displayHarvestDate = false,
  isAppMode,
  isIncluded,
  layerType,
  onToggleLayerInclusion,
  season,
  onSelectCrop,
  onSelectDate,
  selectedCropId
}) => (
  <tr className={classString} key={season}>
    {/* include */}
    <td className={includeDataClassName}>
      <IncludeData
        cropName={cropList[selectedCropId] ? cropList[selectedCropId].name : 'undefined' }
        isIncluded={isIncluded}
        layerType={layerType}
        onToggleLayerInclusion={onToggleLayerInclusion}
        season={season}
      />
    </td>
    <td className={dataTypeClassName}>
      <DataType
        layerType={layerType}
        season={season}
      />
    </td>
    {/*  crop harvested */}
    <td className={cropHarvestedClassName}>
      <HarvestCrop
        cropList={cropList}
        isAppMode={isAppMode}
        onSelectCrop={onSelectCrop}
        selectedCropId={selectedCropId} />
    </td>
    {displayHarvestDate && (<td className={dateHarvestedClassName}>
      <HarvestDate
        date={date}
        onSelectDate={onSelectDate}
      />
    </td>)}
  </tr>
);

HistoryCciRow.propTypes = {
  cropList: propTypes.object.isRequired,
  date: propTypes.string,
  displayHarvestDate: propTypes.bool,
  isAppMode: propTypes.bool.isRequired,
  isIncluded: propTypes.bool.isRequired,
  layerType: propTypes.string.isRequired,
  onSelectCrop: propTypes.func.isRequired,
  onSelectDate: propTypes.func.isRequired,
  onToggleLayerInclusion: propTypes.func.isRequired,
  season: propTypes.string.isRequired,
  selectedCropId: propTypes.number
};

export default HistoryCciRow;
